import styles from "./Button.module.css";

function Button({ children, handleClick, disabled }) {
  return (
    <>
      <button
        disabled={disabled}
        className={disabled ? `${styles.disableButton}` : `${styles.button}`}
        onClick={handleClick}
      >
        {children}
      </button>
    </>
  );
}

export default Button;
